import { getLabelTipoEstipulante } from '@philips-emr/hpms-stipulator-commons';
import TokenConstants from '@philips-emr/hpms-stipulator-commons/lib/constants/token-constants';
import { FieldAPI } from '@philips-emr/tws-components';
import { AuthenticationService } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

interface CardContrato {
  nrSeqContrato: number;
  dsEstipulante: string;
  ieTipoEstipulante: string;
  dtContrato: string;
  dsEndereco: string;
  qtVidas: number;
}

export default class ContratoDossieInfoService {

  public static onAfterFetchContract(contract: CardContrato, fieldCpfCnpj: FieldAPI): void {
    if (isEmptyArrayOrObject(contract)) {
      return;
    }

    const token = AuthenticationService.getJWTToken();
    const ieTipoContrato = token && token.claims[TokenConstants.IE_TIPO_CONTRATO];

    const { ieTipoEstipulante } = contract;

    const showFieldCpfCnpj = !(ieTipoContrato === 'I' && ieTipoEstipulante === 'PJ');

    fieldCpfCnpj.setVisible(showFieldCpfCnpj);
    fieldCpfCnpj.setLabel(getLabelTipoEstipulante(ieTipoEstipulante));
  }

}
